import { render, staticRenderFns } from "./ReformulacionPage.vue?vue&type=template&id=11cceee2"
import script from "./ReformulacionPage.js?vue&type=script&lang=js&external"
export * from "./ReformulacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports